// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import DynamicSubmitController from "./dynamic_submit_controller"
application.register("dynamic-submit", DynamicSubmitController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
